import React, { useState, useRef, useCallback, useEffect } from 'react';
import { PiEraserFill } from "react-icons/pi";
import { MdDone } from "react-icons/md";
// import { Image } from 'react-konva'; 
// import useImage from 'use-image';
import URLImage from './URLImage';
// Defer importing heavy react-konva until use
let StageCmp = null;
let LayerCmp = null;
let LineCmp = null;



const MyKonvaComponent = ({ imageUrl, height, width, stageRef, id, name, index, handleSave }) => {
    const [lines, setLines] = useState([]);
    const [loading, setLoading] = useState(true);
    const [konvaReady, setKonvaReady] = useState(false);
    const isDrawing = useRef(false);
    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const konva = await import('react-konva');
                if (mounted) {
                    StageCmp = konva.Stage;
                    LayerCmp = konva.Layer;
                    LineCmp = konva.Line;
                    setKonvaReady(true);
                }
            } catch (e) {
                console.error('Failed to load react-konva', e);
            }
        })();
        return () => { mounted = false; };
    }, []);

    const handleMouseDown = useCallback((e) => {
        isDrawing.current = true;
        const pos = e.target.getStage().getPointerPosition();
        setLines((prevLines) => [...prevLines, { points: [pos.x, pos.y] }]);
    }, []);

    const handleMouseMove = useCallback((e) => {
        if (!isDrawing.current) return;

        const stage = e.target.getStage();
        const point = stage.getPointerPosition();
        setLines((prevLines) => {
            const lastLine = prevLines[prevLines.length - 1];
            lastLine.points = lastLine.points.concat([point.x, point.y]);
            const newLines = prevLines.slice(0, prevLines.length - 1);
            return [...newLines, lastLine];
        });
    }, []);

    const handleMouseUp = useCallback(() => {
        isDrawing.current = false;
    }, []);

    const handleClear = (e) => {
        e.preventDefault();
        setLines([]);
    };

    const handleImageLoad = () => {
        setLoading(false);
    };

    const handleImageError = () => {
        
        setLoading(false); // You may want to handle errors differently
    };

    return (
        <div>
            <div className='d-flex justify-content-end'>
                <div className='p-2 m-2 border bg-success rounded' onClick={handleClear}>
                    <PiEraserFill size={24} color='white' />
                </div>
                <div className='p-2 m-2 border bg-success rounded' onClick={(e) => handleSave(e, index)}>
                    <MdDone size={24} color='white' />
                </div>
            </div>
            {loading && <p>Loading image...</p>}
            <div>
                {konvaReady ? (
                <StageCmp
                    width={width}
                    height={height}
                    onMouseDown={handleMouseDown}
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    ref={stageRef}
                    id={id}
                    name={name}
                    index={index}
                >
                    <LayerCmp>
                        <URLImage src={imageUrl} onLoad={handleImageLoad} onError={handleImageError} />
                        {!loading && lines.map((line, i) => (
                            <LineCmp
                                key={i}
                                points={line.points}
                                stroke="red"
                                strokeWidth={2}
                                tension={0.5}
                                lineCap="round"
                                globalCompositeOperation="source-over"
                            />
                        ))}
                    </LayerCmp>
                </StageCmp>
                ) : (
                    <div style={{ textAlign: 'center', padding: '12px' }}>Loading drawing tools...</div>
                )}
            </div>
        </div>
    );
};

export default MyKonvaComponent;
